import React from "react";

export const Quote = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="122" height="86" viewBox="0 0 122 86" fill="none" {...props}>
            <path
                d="M122 34.399L95.5671 34.399L113.19 -0.000976562H86.7568L69.1342 34.399V85.999L122 85.999V34.399Z"
                fill="#FE9235"
            />
            <path
                d="M52.8658 85.999L52.8658 34.399L26.4329 34.399L44.0556 -0.000976562H17.6227L4.19617e-05 34.399L4.19617e-05 85.999L52.8658 85.999Z"
                fill="#FE9235"
            />
        </svg>
    )
}
